import {
    CHECK_GIFT_CARD_BALANCE,
    UPDATE_GIFT_CARD_BALANCE,
    GIFT_CARD_ERROR,
    GIFT_CARD_DATA,
    CONTACT_US_FORM_SUCCESS,
    CONTACT_US_FORM_ERROR,
    CONTACT_US_DATA,
    CHANGE_SELECTED_INTL_SHIPPING_COUNTRY,
    CREATE_UNSUBSCRIBE_DATA,
    EMAIL_UNSUBSCRIBE,
    EMAIL_UNSUBSCRIBE_SUCCESS,
    EMAIL_UNSUBSCRIBE_ERROR,
    SAVE_EMAIL_SIGN_UP_DATA,
    SIGN_UP_FOR_EMAIL_SUCCESS,
    SIGN_UP_FOR_EMAIL_ERROR,
    SELECT_CONTACT_US_HELP_TOPIC
} from '../actions/helpActions';

import { SAVE_ORCHESTRATION_CACHE } from '../../../core/js/actions/initialActions';

/* eslint-disable complexity */
export function helpReducer(state = {}, action) {
    switch (action.type) {
        case SAVE_ORCHESTRATION_CACHE:
            return Object.assign(
                {}, state, action.payload.cache.help
            );
        case CHECK_GIFT_CARD_BALANCE:
            return Object.assign(
                {}, state, {
                    giftCard: Object.assign({}, state.giftCard, action.payload)
                }
            );
        case UPDATE_GIFT_CARD_BALANCE:
            return Object.assign(
                {}, state, {
                    giftCard: {
                        balance: action.payload.amount,
                        currencyInfo: action.payload.currencyInfo,
                        messages: {}
                    }
                }
            );
        case GIFT_CARD_DATA:
            return Object.assign(
                {}, state, {
                    giftCard: Object.assign(
                        {}, state.giftCard, action.payload.data, {
                            messages: action.payload.messages
                        }
                    )
                }
            );
        case GIFT_CARD_ERROR:
            return Object.assign(
                {}, state, {
                    giftCard: Object.assign(
                        {}, state.giftCard, {
                            balance: '0.00',
                            messages: action.payload
                        }
                    )
                }
            );

        case CHANGE_SELECTED_INTL_SHIPPING_COUNTRY:
            return Object.assign(
                {}, state, {
                    selectedCountry: action.payload.country
                }
            );

        case CONTACT_US_FORM_SUCCESS:
            return Object.assign(
                {}, state, {
                    contactUsForm: {
                        state: 'submitted',
                        error: false,
                        response: action.payload.response
                    }
                }
            );
        case CONTACT_US_FORM_ERROR:
            return Object.assign(
                {}, state, {
                    contactUsForm: {
                        state: 'submitted',
                        error: true,
                        response: action.payload.response
                    }
                }
            );
        case CONTACT_US_DATA:
            return Object.assign(
                {}, state, {
                    contactUsForm: Object.assign(
                        {}, state.contactUsForm, {
                            messages: action.payload.msgs,
                            formData: action.payload.data
                        }
                    )
                }
            );
        case SELECT_CONTACT_US_HELP_TOPIC:
            return Object.assign(
                {}, state, {
                    contactUsForm: Object.assign(
                        {}, state.contactUsForm, {
                            helpTopicText: action.payload.helpTopic
                        }
                    )
                }
            );

        case CREATE_UNSUBSCRIBE_DATA:
            return Object.assign(
                {}, state, {
                    emailUnsubscribe: Object.assign(
                        {}, state.emailUnsubscribe, action.payload.create.data, {
                            msgs: action.payload.create.msgs,
                            unsubscribeSuccessful: undefined
                        }
                    )
                }
            );

        case EMAIL_UNSUBSCRIBE:
            return Object.assign(
                {}, state, {
                    emailUnsubscribe: Object.assign(
                        {}, state.emailUnsubscribe
                    )
                }
            );

        case EMAIL_UNSUBSCRIBE_SUCCESS:
            return Object.assign(
                {}, state, {
                    emailUnsubscribe: Object.assign(
                        {}, state.emailUnsubscribe, {
                            responseData: action.payload.email,
                            error: false,
                            unsubscribeSuccessful: true,
                            msgs: {}
                        }
                    )
                }
            );

        case EMAIL_UNSUBSCRIBE_ERROR:
            return Object.assign(
                {}, state, {
                    emailUnsubscribe: Object.assign(
                        {}, state.emailUnsubscribe, {
                            responseData: action.payload,
                            error: true,
                            unsubscribeSuccessful: false
                        }
                    )
                }
            );

        case SAVE_EMAIL_SIGN_UP_DATA:
            return Object.assign(
                {}, state, {
                    emailSignUp: Object.assign({}, state.emailSignUp, {
                        formData: action.payload.formData
                    })
                }
            );

        case SIGN_UP_FOR_EMAIL_SUCCESS:
            return Object.assign(
                {}, state, {
                    emailSignUp: Object.assign({}, state.emailSignUp, {
                        formData: action.payload.formData,
                        error: null,
                        signUpSuccessful: true
                    })
                }
            );

        case SIGN_UP_FOR_EMAIL_ERROR:
            return Object.assign(
                {}, state, {
                    emailSignUp: Object.assign({}, state.emailSignUp, {
                        error: action.payload.error,
                        signUpSuccessful: false
                    })
                }
            );

        default:
            return state;
    }
}
